import React from 'react';
import ReactDOM from 'react-dom/client';

import '../app/components/App/typescript';

import Main from '../Main';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('root');

  if (root) {
    const props = JSON.parse(root.dataset.props ?? '{}');

    ReactDOM.createRoot(root).render(<Main {...props} />);
  }
});
